import { useState } from "react";
import { Button } from "@/deps/ui-library";
import { useDiscardDraft } from "@/api/queries";
import { Dialog } from "@/components/Dialog";

/**
 * Edit and Delete on a draft's own page. A draft has no number and nothing posted, so it can go
 * without trace, and that is what the dialog says before it does.
 */
export function DraftActions({
  kind,
  label,
  id,
  onEdit,
  onDeleted,
}: {
  kind: "invoices" | "creditNotes" | "bills" | "debitNotes" | "quotations" | "purchaseOrders";
  /** What it is, in a sentence: "invoice". */
  label: string;
  id: string;
  onEdit: () => void;
  onDeleted: () => void;
}) {
  const discard = useDiscardDraft(kind);
  const [confirming, setConfirming] = useState(false);

  return (
    <>
      <Button
        colorScheme="default"
        variant="ghost"
        size="sm"
        leftIcon="Trash2"
        onClick={() => setConfirming(true)}
      >
        Delete
      </Button>
      <Button colorScheme="default" variant="outline" size="sm" leftIcon="Pencil" onClick={onEdit}>
        Edit
      </Button>

      <Dialog
        open={confirming}
        onClose={() => setConfirming(false)}
        title={`Delete this draft ${label}?`}
        description="It has no number and nothing was posted, so it is removed completely."
        footer={
          <Button
            colorScheme="danger"
            variant="solid"
            size="sm"
            disabled={discard.isPending}
            onClick={() => discard.mutate(id, { onSuccess: onDeleted })}
          >
            {discard.isPending ? "Deleting" : "Delete draft"}
          </Button>
        }
      >
        {discard.isError ? (
          <p role="alert" className="text-bad-text text-sm">
            {discard.error instanceof Error ? discard.error.message : "That could not be deleted."}
          </p>
        ) : null}
      </Dialog>
    </>
  );
}
